import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { BankAccountPublicIDSelect } from "Components/Shared/Inputs/BankAccountPublicIDSelect";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import {
  Resources,
  useResource,
  getResourcePath,
} from "Translations/Resources";
import { Trans } from "react-i18next";

type Props = {
  selectedPublicID: string;
  accounts: Array<BankAccountListItem>;
  onSelect: (accountPublicID: string) => void;
};

const COMPONENT_RESOURCES = Resources.Pages.Content.BankAccounts.DeleteAccount;

export const ReplacementPrimaryAccountSelection = ({
  onSelect,
  accounts,
  selectedPublicID,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={2}>
      <Box display="flex" alignItems="center">
        <WarningAmberOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
        <Typography>
          <Trans
            i18nKey={getResourcePath(COMPONENT_RESOURCES.PrimaryAccountWarning)}
            components={{
              bold: <Typography component="strong" fontWeight="bold" />,
            }}
          />
        </Typography>
      </Box>
      <Stack gap={2} width="100%">
        <Typography component="label" htmlFor="replacementPrimaryAccount">
          {t(COMPONENT_RESOURCES.ReplacementPrimaryAccount)}
        </Typography>
        <BankAccountPublicIDSelect
          name="replacementPrimaryAccount"
          isBalanceVisible
          accounts={accounts}
          value={selectedPublicID}
          onChange={(e) => {
            e.target.value && onSelect(e.target.value.toString());
          }}
        />
      </Stack>
    </Stack>
  );
};
